import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { Controller } from "react-hook-form";
import PropTypes from 'prop-types';
export const GenericToggleGroup = ({
    control,
    errors,
    disabled = false,
    name,
    options,
    orientation = 'horizontal',
    size = '',
    className = '',
    onChangeCallback // Nueva prop para el callback
}) => {
    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { onChange, onBlur, value } }) => (
                <div className={className}>
                    <ToggleButtonGroup
                        value={value}
                        onChange={(val) => {
                            onChange(val); // Actualiza el valor en react-hook-form
                            onChangeCallback?.(val); // Llama al callback si existe
                        }}
                        onBlur={onBlur}
                        type="radio"
                        name={name}
                        vertical={orientation === 'vertical'}
                        size={size}
                        className="w-100 shadow-sm"
                    >
                        {options.map((option) => {
                            // Comparación flexible para manejar booleanos y strings
                            const isSelected = String(value) === String(option.value);
                            return (
                                <ToggleButton
                                    key={option.value}
                                    id={`${name}-${option.value}`}
                                    variant={isSelected ? "primary" : "outline-primary"}
                                    value={option.value}
                                    disabled={disabled}
                                    className="fw-bold"
                                >
                                    {option.label}
                                </ToggleButton>
                            );
                        })}
                    </ToggleButtonGroup>
                    <span className="input-feedback">{errors[name]?.message ?? " "}</span>
                </div>
            )}
        />
    );
};

GenericToggleGroup.propTypes = {
    control: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.string.isRequired
        })
    ).isRequired,
    orientation: PropTypes.oneOf(['horizontal', 'vertical']),
    size: PropTypes.oneOf(['sm', 'lg', '']),
    className: PropTypes.string
};
